export const GET_PHYSICAL_LIST_DATA = 'GET_PHYSICAL_LIST_DATA'
export const SET_PHYSICAL_LOADING = 'SET_PHYSICAL_LOADING'
export const CLEAR_PHYSICAL = 'CLEAR_PHYSICAL'
